import { useWidgetConfig } from '@/context/WidgetConfigContext';
import { COLORS } from '@/helpers/constants/theme';
import { useHoverBackground } from '@/hooks/useHoverBackground';
import type { I_WalletPassButtonProps } from '@/types/Wallet';

export const WalletPassButton = ({
  logo,
  text,
  filled = false,
  disabled,
  ...restProps
}: I_WalletPassButtonProps) => {
  const { theme } = useWidgetConfig();

  const { backgroundColor = COLORS.BRAND_SECONDARY, textColor = COLORS.TEXT_INVERSE } =
    theme?.secondaryButton ?? {};

  const { backgroundColor: hoverBackground, hoverHandlers } = useHoverBackground({
    baseColor: backgroundColor,
  });

  return (
    <button
      {...restProps}
      onMouseEnter={(e) => {
        hoverHandlers.onMouseEnter?.();
        restProps.onMouseEnter?.(e);
      }}
      onMouseLeave={(e) => {
        hoverHandlers.onMouseLeave?.();
        restProps.onMouseLeave?.(e);
      }}
      disabled={disabled}
      className={`secondary-button relative z-[3] flex h-12 w-full items-center justify-center gap-2 rounded-2xl px-1 py-2 text-[12px] font-medium transition-all duration-200 focus:outline-none ${disabled ? 'cursor-not-allowed opacity-50' : ''} `}
      style={{
        backgroundColor: filled ? hoverBackground : 'transparent',
        color: filled ? backgroundColor : textColor,
        border: `1px solid ${backgroundColor}`,
      }}
    >
      {logo && <img src={logo} alt='Wallet Logo' className='h-6 w-auto rounded-sm' />}

      <div className='flex flex-col items-start'>
        <h5 className='mt-[1px] leading-none'>{text?.firstLine}</h5>

        {text?.secondLine && (
          <span className='whitespace-nowrap text-base leading-tight'>{text.secondLine}</span>
        )}
      </div>
    </button>
  );
};
